import React, { useState } from "react";
import { Button, Form, Input, Radio, Select, DatePicker } from "antd";
import { framework_tool, component_tool } from '@/tool'
import moment from 'moment';
import './index.less'
import { WizRepairAuthority, WizAuthority } from "@/containers/common";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { WizClassifySelectRow, WizBraftEditorPlus } from "@/containers/common"

let { WizAvatarUpload } = framework_tool;
const { Wizmessage, WizModal, } = component_tool;
const { RangePicker, MonthPicker } = DatePicker;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const brandList = [
  { value: 'B', label: '别克', id: 0 },
  { value: 'X', label: '雪佛兰', id: 1 },
  { value: 'K', label: '凯迪拉克', id: 2 },
  { value: 'O', label: '跨品牌', id: 9 }
]
const moduleList = [
  { value: 'S', label: '销售', id: 0 },
  { value: 'N', label: '售后服务', id: 1 },
  { value: 'T', label: '售后技术', id: 2 },
  { value: 'C', label: '诚新二手车', id: 3 },
  { value: 'X', label: '校企合作', id: 4 },
  { value: 'J', label: '集团销售', id: 5 },
  { value: 'O', label: '跨业务块', id: 9 }
]

const programSourceList = [
  { id: 1, label: "别克销售" },
  { id: 2, label: "雪佛兰销售" },
  { id: 3, label: "凯迪拉克销售" },
  { id: 4, label: "售后技术" },
  { id: 5, label: "售后非技术" },
  { id: 6, label: "二手车" },
  { id: 8, label: "集团销售" },
  { id: 9, label: "校企合作" },
  { id: 10, label: "融入辅导_相达" },
  { id: 11, label: "融入辅导_申先" },
  { id: 12, label: "TAC技术支持" },
  { id: 13, label: "其它" },
  { id: 14, label: "车工坊" },
  { id: 15, label: "德科" },
]

const CourseUpdateList = ({ form, data, submit, cancel, ...props }) => {

  const [richTextVisible, setRichTextVisible] = useState(false)
  const [changeItem, setChangeItem] = useState({})
  const [changeVisible, setChangeVisible] = useState(false)
  const [groupVisible, setGroupVisible] = useState(false)
  const [bigVersion, setBigVersion] = useState(true)
  const [locRichText, setLocRichText] = useState('')

  const { getFieldDecorator, validateFields, setFields, resetFields, getFieldsValue } = form
  const _submit = (pass) => {
    if (pass === 3) {
      setChangeVisible(false)
      // cancel && cancel()
      resetFields()
      return;
    } else {
      validateFields((err, values) => {
        if (!err) {
          if (changeItem.title == '开发/更新完成时间') {
            values.value = values.value?values.value.format("YYYY-MM-01 00:00:00"):'';
          } else if (changeItem.title == '课程时间') {
            if (values.value?.length > 1) {
              values.value = [values.value[0].format('YYYY-MM-DD HH:mm:ss'), values.value[1].format('YYYY-MM-DD HH:mm:ss')]
            }
          } else if (changeItem.title == '封面') {
            if (values.value?.length > 0) {
              values.value = values.value[0].fileId
            }
          }
          values.title = changeItem.title
          if (data.find(x => x.title == values.title).beforeValue == values.value) {
            Wizmessage.error('操作失败，调整内容与原内容一致，请确认后重试')
          } else if (!values.value || values.value?.length == 0 || values.value == '<p></p>') {
            Wizmessage.error('请修改内容')
          } else if (values.title == '受众' &&( !values.value?.groupId && !values.value?.isAll && values.value?.orgIds?.length == 0 &&
            values.value?.positionIds?.length == 0 &&
            values.value?.personIds?.length == 0 && values.value?.positionCategoryIds?.length == 0||
            values.value?.groupId?.length==0
            )) {
            Wizmessage.error('请修改内容')
          } else {
            submit && submit({ ...values });
            setChangeVisible(false)
            resetFields()
          }
        }
      });
    }
  }
  // formatLink = ({ fileType, fileId, address }) => {
  //   let newFileId = getOssFilePath(fileId[0]?.fileId || '')
  //   let fileOriginalName = fileId[0]?.fileOriginalName || ''
  //   if (fileType == 0) {
  //     return <a href={newFileId}>
  //       {fileOriginalName}
  //     </a>
  //   } else {
  //     return address
  //   }
  // }
  // const { contentType, orderNum, name, fileType = 0, address, fileId = '', isRead } = data || {}
  formatMust = (title, value) => {
    let desc = false
    if (title == '品牌' && !value) {
      desc = true
    } else if (title == '功能块' && !value) {
      desc = true
    } else if (title == '序号' && !value) {
      desc = true
    } else if (title == '开发/更新完成时间' && !value) {
      desc = true
    } else if (title == '版本号' && !value) {
      desc = true
    } else if (title == '课程编码') {
      desc = true
    }
    return desc
  }
  lookRichText = (value) => {
    setLocRichText(value)
    setRichTextVisible(true)

  }
  formatContent = (title, value) => {
    if (title == '品牌') {
      let desc = ''
      if (value || value === 0) {
        desc = brandList.find(x => x.id == value)?.label
      }
      return desc
    } else if (title == '功能块') {
      let desc = ''
      if (value || value === 0) {
        desc = moduleList.find(x => x.id == value)?.label
      }
      return desc
    } else if (title == '课程来源') {
      let desc = ''
      if (value || value === 0) {
        desc = programSourceList.find(x => x.id == value)?.label
      }
      return desc
    } else if (title == '开发/更新完成时间') {
      let desc = ''
      if (value) {
        console.log(value, '你是七七')
        desc = moment(value).format('YYYY-MM')
        console.log(desc, '你是七七')

      }
      return desc
    } else if (title == '课程时间') {
      let desc = ''
      if (value?.length > 1) {
        desc = moment(value[0]).format('YYYY-MM-DD') + '~' + moment(value[1]).format('YYYY-MM-DD')
      }
      return desc
    } else if (title == '课程分类') {
      let desc = ''
      if (value?.length > 0) {
        let typeArr = []
        value.forEach(item => {
          typeArr.push(item.title)
        })
        desc = typeArr.join('，')
      }
      return desc
    } else if (title == '封面') {
      return (
        <>
          {value ?
            <PhotoProvider
              toolbarRender={({ onScale, scale }) => {
                return (
                  <>
                    <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale + 1)} />
                    <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale - 1)} />
                  </>
                );
              }}>
              <div className="foo">
                <PhotoView key={'img_' + value} src={getOssFilePath(value)}>
                  <a>查看</a>
                </PhotoView>
              </div>
            </PhotoProvider>
            : null}
        </>
      )
    } else if (title == '介绍') {
      return (<>
        {value ? <a onClick={() => lookRichText(value)}>预览</a> : null}
      </>)
    } else if (title == '受众') {
      return (
        <>
          {value ? (!value?.groupId && !value?.isAll && value?.orgIds?.length == 0 && value?.positionIds?.length == 0 &&
            value?.personIds?.length == 0 && value?.positionCategoryIds?.length == 0 ?
            null : <WizRepairAuthority value={value} mode='Button' />) : null}
        </>
      )


    } else {
      return value
    }
  }
  formatBtn = (item) => {
    let desc = false
    if (!item.afterValue && item.afterValue != 0) {
      desc = true
    } else if (item.afterValue?.length == 0) {
      desc = true
    }
    if (item.title == '课程编码') {
      desc = false
    }
    if (item.title == '受众') {
      if (!item.afterValue?.groupId && !item.afterValue?.isAll && item.afterValue?.orgIds?.length == 0 && item.afterValue?.positionIds?.length == 0 &&
        item.afterValue?.personIds?.length == 0 && item.afterValue?.positionCategoryIds?.length == 0) {
        desc = true
      }
    }
    return desc
  }
  formatControl = (item) => {
    let desc = false
    if (item.title == '课程时间' || item.title == '课程分类') {
      if (item.afterValue && item.afterValue.length > 0) {
        desc = true
      }
    } else if (item.title == '封面' || item.title == '介绍') {
      if (item.afterValue) {
        desc = true
      }
    } else if (item.title == '品牌' || item.title == '功能块') {
      if (item.afterValue || item.afterValue === 0) {
        desc = true
      }
    } else if (item.title == '受众') {
      if ((!item.afterValue?.groupId && !item.afterValue?.isAll && item.afterValue?.orgIds?.length == 0 && item.afterValue?.positionIds?.length == 0 &&
        item.afterValue?.personIds?.length == 0 && item.afterValue?.positionCategoryIds?.length == 0) || !item.afterValue) {
        desc = false
      } else {
        desc = true
      }
    } else {
      if (item.afterValue && item.title != '课程编码' && item.title != '版本号') {
        desc = true
      }
    }
    return desc
  }
  formatCancel = (item) => {
    let desc = false
    if (item.title == '品牌' || item.title == '功能块') {
      if (item.beforeValue || item.beforeValue == 0) {
        return true
      }
    } else {
      if (item.beforeValue) {
        return true
      }
    }
    return desc
  }
  openChange = (record) => {
    console.log(record, 'record')
    record.value = record.afterValue || record.afterValue == 0 ? record.afterValue : record.beforeValue
    setChangeItem(record)
    setChangeVisible(true)
  }
  cancelChange = (record) => {
    submit(record, 2)
  }
  changeVersion = (item, type) => {
    let desc = ''
    let arr = []
    let unitArr = []
    if (item.beforeValue) {
      if (type == 1) {
        arr = item.beforeValue.split('.')
        desc = Number(arr[1]) + 1
        unitArr = arr[0].split('V')
        desc = 'V' + unitArr[1] + '.' + desc
      } else {
        arr = item.beforeValue.split('.')
        desc = Number(arr[0].split('V')[1]) + 1
        desc = 'V' + desc + '.0'
      }
    } else {
      desc = 'V1.0'
    }
    submit({ title: '版本号', value: desc })
    setBigVersion(!bigVersion)
  }
  formatScoId = (brandVal, moduleVal, orderNumberVal, dateString) => {
    let programFinishDate
    if (dateString) {
      programFinishDate = dateString
    } else if (!dateString && (data.find(x => x.title == '开发/更新完成时间').afterValue || data.find(x => x.title == '开发/更新完成时间').beforeValue)) {
      programFinishDate = data.find(x => x.title == '开发/更新完成时间').afterValue ? moment(data.find(x => x.title == '开发/更新完成时间').afterValue).format("YYYY-MM") : moment(data.find(x => x.title == '开发/更新完成时间').beforeValue).format("YYYY-MM")
    }
    let brand = brandVal || brandVal === 0 ? brandVal : (data.find(x => x.title == '品牌').afterValue || data.find(x => x.title == '品牌').afterValue === 0 ? data.find(x => x.title == '品牌').afterValue : data.find(x => x.title == '品牌').beforeValue)
    let module = moduleVal || moduleVal === 0 ? moduleVal : (data.find(x => x.title == '功能块').afterValue || data.find(x => x.title == '功能块').afterValue === 0 ? data.find(x => x.title == '功能块').afterValue : data.find(x => x.title == '功能块').beforeValue)
    let orderNumber = orderNumberVal ? orderNumberVal.toString() : (data.find(x => x.title == '序号').afterValue ? data.find(x => x.title == '序号').afterValue?.toString() : data.find(x => x.title == '序号').beforeValue?.toString())
    let versionNumber = data.find(x => x.title == '版本号').afterValue.split('.')[0]
    if ((brand || brand === 0) && (module || module === 0) && orderNumber && orderNumber.length <= 4 && programFinishDate) {
      let brandDesc = brandList.find(x => x.id == brand).value
      let moduleDesc = moduleList.find(x => x.id == module).value
      let orderNumberDesc = orderNumber
      for (let i = 0; i < 3; i++) {
        if (orderNumberDesc.length < 4) {
          orderNumberDesc = '0' + orderNumberDesc
        }
      }
      let arr = programFinishDate.split('-')
      let programFinishDateDesc;
      if (arr.length > 1) {
        programFinishDateDesc = arr[0] + arr[1]
      }
      submit({ title: '课程编码', value: brandDesc + moduleDesc + orderNumberDesc + versionNumber + programFinishDateDesc })
    }
  }
  let initValue
  if (changeItem.title == '课程时间' && changeItem.value[0]) {
    initValue = [moment(changeItem.value[0]), moment(changeItem.value[1])]
  }
  console.log(changeItem, 'changeItem')
  return (
    <div className='course-update-list'>
      <div className='question-header-title' type='flex' justify='center' align='middle'>
        <div className="item-value course-item" span={3} >
          课程信息
        </div>
        <div className="item-value content-item" span={7}>
          当前内容
        </div>
        <div className="item-value change-item center-col" span={3}>
          是否调整
        </div>
        <div className="item-value after-item" span={7}>
          调整后内容
        </div>
        <div className="item-value operate-item" span={4}>
          操作
        </div>
      </div>
      <WizModal visible={richTextVisible}
        onCancel={() => setRichTextVisible(false)}
        footer={null}
        style={{ minWidth: 1000 }}
        title='介绍'
      // key={this.state.scheduleListModalKey}
      >
        <div
          className="rich-text-style"
          dangerouslySetInnerHTML={{
            __html: locRichText
          }}
        />
      </WizModal>
      {
        data.map(item => {
          return (
            <div className='question-header-title'>
              <div className="item-value course-item">
                {formatMust(item.title, item.beforeValue) ? <span className="red-star">*</span> : null}{item.title}
              </div>
              <div className="item-value content-item">
                {formatContent(item.title, item.beforeValue)}
              </div>
              <div className="item-value change-item center-col">
                {item.adjust == 1 ? '是' : '否'}
              </div>
              <div className="item-value after-item">
                {formatContent(item.title, item.afterValue)}
              </div>
              <div className="item-value operate-item">
                {item.title == '版本号' ?
                  <>
                    {
                      bigVersion && item.beforeValue.indexOf('.9') == -1 ?
                        <a className='click-btn' onClick={() => changeVersion(item, 1)}> 调整为小版本 </a>
                        : <a className='click-btn' onClick={() => changeVersion(item, 2)}> 调整为大版本 </a>
                    }
                  </>
                  : null
                }
                {item.title != '版本号' || item.title != '课程编码' ?
                  <>
                    {formatBtn(item) ?
                      <a className='click-btn' onClick={() => openChange(item)}> 调整 </a>
                      : null
                    }
                    {formatControl(item) ?
                      <>
                        {formatCancel(item) ?
                          <a className='click-btn' onClick={() => cancelChange(item)}> 取消调整 </a>
                          : null}
                        <a className='click-btn' onClick={() => openChange(item)}> 重新调整 </a>
                      </>
                      : null
                    }
                  </>
                  : null
                }
              </div>
            </div>
          )
        })
      }
      <WizModal visible={changeVisible}
        onCancel={() => setChangeVisible(false)}
        destroyOnClose={true}
        footer={null}
        style={{ minWidth: 1000 }}
        title={changeItem.title}
      // key={this.state.scheduleListModalKey}
      >
        <Form {...formItemLayout}>
          {changeItem.title == '课程名称' ?
            <Form.Item label='课程名称'>
              {getFieldDecorator('value', {
                initialValue: changeItem.value,
              })(<Input placeholder='请输入' maxLength={50} />)
              }
            </Form.Item>
            : null}
          {changeItem.title == '课程来源' ?
            <Form.Item label='课程来源'>
              {getFieldDecorator('value', {
                initialValue: changeItem.value,
              })(<Select defaultValue="lucy" style={{ width: 120 }} >
                {
                  programSourceList.map(item => {
                    return (
                      <Option value={item.id}>{item.label}</Option>
                    )
                  })
                }
              </Select>)
              }
            </Form.Item>
            : null}
          {changeItem.title == '品牌' ?
            <Form.Item label='品牌'>
              {getFieldDecorator('value', {
                initialValue: changeItem.value,
              })(<Select defaultValue="lucy" style={{ width: 120 }}
              // onChange={(value) => formatScoId(value)}
              >
                {
                  brandList.map(item => {
                    return (
                      <Option value={item.id}>{item.label}</Option>
                    )
                  })
                }
              </Select>)
              }
            </Form.Item>
            : null}
          {changeItem.title == '功能块' ?
            <Form.Item label='功能块'>
              {getFieldDecorator('value', {
                initialValue: changeItem.value,
              })(<Select defaultValue="lucy" style={{ width: 120 }}
              // onChange={(value) => formatScoId(null, value)}
              >
                {
                  moduleList.map(item => {
                    return (
                      <Option value={item.id}>{item.label}</Option>
                    )
                  })
                }
              </Select>)
              }
            </Form.Item>
            : null}
          {changeItem.title == '序号' ?
            <Form.Item label='序号'>
              {getFieldDecorator('value', {
                initialValue: changeItem.value,
                rules: [{
                  validator: (rule, value, callback) => {
                    if (value && (!Number(value) || (value.toString().length != 4 || value.toString().indexOf('.') > -1))) {
                      callback('序号为4位数字')
                    }
                    callback();
                  }
                }],
              })(<Input type='number' placeholder='请输入' maxLength={4}
              // onChange={(e) => formatScoId(null, null, e.target.value)}
              />)
              }
            </Form.Item>
            : null}
          {changeItem.title == '开发/更新完成时间' ?
            <Form.Item label='开发/更新完成时间'>
              {getFieldDecorator('value', {
                initialValue: changeItem.value ? moment(changeItem.value) : '',
              })(<MonthPicker
                key='programFinishDate'
                //  showTime={'YYYY-MM'}
                // format={'YYYY-MM'}
                placeholder={'请选择开发/更新完成时间'}
              // onChange={(date, dateString) => formatScoId(null, null, null, dateString)}
              />)
              }
            </Form.Item>
            : null}
          {changeItem.title == '课程时间' ?
            <Form.Item label='课程时间'>
              {getFieldDecorator('value', {
                initialValue: initValue
              })(<RangePicker showTime format={'YYYY-MM-DD HH:mm:ss'} />)
              }
            </Form.Item>
            : null}
          {changeItem.title == '课程分类' ?
            <Form.Item label='课程分类'>
              {getFieldDecorator('value', {
                initialValue: changeItem.value,
              })(<WizClassifySelectRow
                returnKey={true}
                // apiPath={'questionType/normalNodeList'}
                apiProps={{ type: 1 }}
                initSelects={changeItem.value ? changeItem.value : []}
                wizTreeSelectListProps={{
                  item: {
                    icon: 'unordered-list',
                    title: '课程分类',
                    tips: '请勾选所属课程分类'
                  },
                  multiple: true,
                  treeCheckable: false,
                  checkable: true,
                  showSelectList: true,
                  treeProps: { checkStrictly: true }
                }}
              />)
              }
            </Form.Item>
            : null}
          {changeItem.title == '封面' ?
            <Form.Item label='封面'>
              {
                getFieldDecorator('value', {
                  initialValue:
                    changeItem.value ? [
                      { fileId: changeItem.value }
                    ] : []
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      let result = true;
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (file.type.indexOf('image/') == -1) {
                        Wizmessage.error('只能上传图片类型,请重新选择!');
                        result = false;
                      } else if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!');
                        result = false;
                      }
                      return result;
                    }}
                  />
                )
              }
            </Form.Item>
            : null}
          {changeItem.title == '介绍' ?
            <Form.Item label='介绍'>
              {
                getFieldDecorator('value', {
                  initialValue: changeItem.value
                })(
                  <WizBraftEditorPlus links={[0, 1, 2, 3]} />
                )
              }
            </Form.Item>
            : null}
          {changeItem.title == '受众' ?
            <Form.Item label='受众'>
              {
                getFieldDecorator('value', {
                  initialValue: changeItem.value
                })(
                  <WizAuthority
                    mode={'Form'}
                    keys={['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']}
                    record={{
                      value: changeItem.value && changeItem.value
                    }
                    }
                  // hasRadioGroup={false}
                  />
                )
              }
            </Form.Item>
            : null}
          <Form.Item wrapperCol={{ span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span }}>
            <Button type='primary' onClick={() => _submit(2)}>确定</Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button onClick={() => _submit(3)}>取消</Button>
          </Form.Item>
        </Form>
      </WizModal>
    </div>
  )
}

let CourseUpdateListForm = Form.create()(CourseUpdateList)
export {
  CourseUpdateListForm,
}

